import { REPORTS } from "@/constants/testIds";

/** Tabla de servicios mas vendidos (por cantidad de turnos completados). */
export function MostSoldTable({ data, testId = REPORTS.topServicesTable }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={testId}>
      <h3 className="text-sm font-medium text-foreground mb-3">Servicios mas vendidos</h3>
      {data.length === 0 ? (
        <p className="text-sm text-muted-foreground py-6 text-center">Sin turnos completados en este periodo.</p>
      ) : (
        <div className="space-y-2">
          {data.map((s, i) => (
            <div key={s.service_id} className="flex items-center justify-between text-sm py-1.5 border-b border-border/60 last:border-0">
              <span className="text-foreground"><span className="text-muted-foreground mr-2">{i + 1}.</span>{s.service_name}</span>
              <span className="font-medium text-foreground">{s.count} {s.count === 1 ? "turno" : "turnos"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/** Tabla de servicios mas rentables (ganancia total = margen unitario x cantidad). */
export function MostProfitableTable({ data, testId = REPORTS.topProfitableTable }) {
  return (
    <div className="bg-white border border-border rounded-xl p-5" data-testid={testId}>
      <h3 className="text-sm font-medium text-foreground mb-3">Servicios mas rentables</h3>
      {data.length === 0 ? (
        <p className="text-sm text-muted-foreground py-6 text-center">Sin datos de margen para este periodo.</p>
      ) : (
        <div className="space-y-2">
          {data.map((s, i) => (
            <div key={s.service_id} className="flex items-center justify-between text-sm py-1.5 border-b border-border/60 last:border-0">
              <span className="text-foreground"><span className="text-muted-foreground mr-2">{i + 1}.</span>{s.service_name}</span>
              <span className="font-medium text-foreground">${s.total_profit.toFixed(2)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
